module.exports = __webpack_public_path__ + "img/personal-folder-icon.4f495a9d.svg";